import { queryClient } from '@/config/query-client'

type KeyItem = {
  [key: string]: {
    queryKey: string[]
    onDestroy?: 'reset' | 'remove'
  }
}

type KeyStore = {
  [key: string]: KeyItem
}

const keyStore: KeyStore = {
  events: {
    all: {
      queryKey: ['events'],
      onDestroy: 'remove',
    },
    details: {
      queryKey: ['events/details'],
      onDestroy: 'remove',
    },
    rechargesSummary: {
      queryKey: ['events/recharges-summary'],
      onDestroy: 'remove',
    },
    recharges: {
      queryKey: ['events/recharges'],
      onDestroy: 'remove',
    },
    refundsSummary: {
      queryKey: ['events/refunds-summary'],
      onDestroy: 'remove',
    },
    refunds: {
      queryKey: ['events/refunds'],
      onDestroy: 'remove',
    },
    refundsPending: {
      queryKey: ['events/refunds-pending'],
      onDestroy: 'remove',
    },
    legacy: {
      queryKey: ['events/legacy'],
      onDestroy: 'remove',
    },
  },
  registroComanda: {
    dashboard: {
      queryKey: ['registros-comanda-dashboard'],
      onDestroy: 'remove',
    },
    list: {
      queryKey: ['registros-comanda'],
      onDestroy: 'remove',
    },
    show: {
      queryKey: ['registro-comanda'],
      onDestroy: 'remove',
    },
  },
  companies: {
    infinite: {
      queryKey: ['companies/infinite'],
    },
  },
  priceList: {
    infinite: {
      queryKey: ['price-list/infinite'],
      onDestroy: 'reset',
    },
    configureInfinite: {
      queryKey: ['price-list/configure-infinite'],
      onDestroy: 'reset',
    },
    product: {
      queryKey: ['price-list/product-info'],
      onDestroy: 'remove',
    },
    products: {
      queryKey: ['price-list/products'],
      onDestroy: 'remove',
    },
    productOptions: {
      queryKey: ['price-list/product-options'],
      onDestroy: 'remove',
    },
    categoryOptions: {
      queryKey: ['price-list/category-options'],
      onDestroy: 'remove',
    },
    imageGallery: {
      queryKey: ['price-list/image-gallery'],
      onDestroy: 'remove',
    },
  },
  tax: {
    ncmList: {
      queryKey: ['tax/ncm-list'],
    },
    cfopList: {
      queryKey: ['tax/cfop-list'],
    },
    icmsOrigemList: {
      queryKey: ['tax/icms-origem-list'],
    },
    icmsSituacaoList: {
      queryKey: ['tax/icms-situacao-list'],
    },
    icmsModalidadeList: {
      queryKey: ['tax/icms-modalidade-list'],
    },
    pisCofinsTipoList: {
      queryKey: ['tax/pis-cofins-tipo-list'],
    },
    pisCofinsSituacaoList: {
      queryKey: ['tax/pis-cofins-situacao-list'],
    },
    group: {
      queryKey: ['tax/group-list'],
    },
  },
  settings: {
    token: {
      queryKey: ['settings/token'],
      onDestroy: 'reset',
    },
    company: {
      queryKey: ['settings/company-config'],
      onDestroy: 'reset',
    },
  },
}

function destroyKeysCache() {
  Object.values(keyStore).forEach((keys) => {
    Object.values(keys).forEach((keyItem) => {
      const { queryKey, onDestroy } = keyItem

      if (onDestroy) {
        if (onDestroy === 'reset') {
          return queryClient.resetQueries({ queryKey })
        }

        if (onDestroy === 'remove') {
          return queryClient.removeQueries({ queryKey })
        }
      }
    })
  })
}

export { keyStore, destroyKeysCache }
